<template>
  <div class="row-stretch">
    <!-- Content column -->
    <div style="flex: 1 0">
      <slot></slot>
    </div>

  </div>
</template>


<script setup>
</script>

<style scoped>
</style>